import { render, staticRenderFns } from "./regionform.vue?vue&type=template&id=a02a01ee&"
import script from "./regionform.vue?vue&type=script&lang=js&"
export * from "./regionform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports